import type { IconData } from '@stacksjs/iconify-core'

export const verticalAlignTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 16h480v32H16zm139.883 179.883l22.627 22.627L240 157.02V456h32V157.02l61.49 61.49l22.627-22.627L256 95.764z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default verticalAlignTop
